import axios from 'axios';

// Get landing page data - roles with their assigned reports
export async function getReportAccessListAPI(roleName) {
    let resultList = [];
    
    try {
        const response = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_API}system/reportAccess/list`,
            params: { roleName: roleName || '' },
            headers: { 'content-type': 'application/json' }
        });
        resultList = response.data;
    } catch (error) {
        throw error;
    }
    
    return resultList;
}

// Get all active accounting reports
export async function getDocumentsAPI() {
    let resultList = [];
    
    try {
        const response = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_API}system/reportAccess/documents`,
            headers: { 'content-type': 'application/json' }
        });
        resultList = response.data;
    } catch (error) {
        throw error;
    }
    
    return resultList;
}

// Get report access for specific role
export async function getRoleReportAccessAPI(roleId) {
    let resultList = [];
    
    try {
        const response = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_API}system/reportAccess/role/${roleId}`,
            headers: { 'content-type': 'application/json' }
        });
        resultList = response.data;
    } catch (error) {
        throw error;
    }
    
    return resultList;
}

// Update report access for a role
export async function updateReportAccessAPI(roleId, documentIds, userId) {
    let result = {};
    
    try {
        const response = await axios({
            method: 'PUT',
            url: `${process.env.REACT_APP_BACKEND_API}system/reportAccess/update`,
            data: { roleId, documentIds, userId }
        });
        result = response.data;
    } catch (error) {
        throw error;
    }
    
    return result;
}

// Get all active roles for dropdown
export async function getActiveRolesAPI() {
    let resultList = [];
    
    try {
        const response = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_API}system/roles/search`,
            params: { roleName: '' },
            headers: { 'content-type': 'application/json' }
        });
        // Filter only active roles
        resultList = response.data.filter(role => role.is_active === true);
    } catch (error) {
        throw error;
    }
    
    return resultList;
}


// fetch Reports list
export async function fetchAccountingReportsAccessList(userID) {
	let details = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/reportAccess/reportslist`,
			params: userID ? { userID } : {},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}

	return details;
}
